#### Removal of support for accessing recruitment agency information

On the 9th of December 2024, we will be removing support for accessing recruitment agency information from the SEEK API.

The SEEK API previously supported the retrieval of recruitment agency information associated with a position opening through the [`PostingRequester`] type.
This information was intended to help hirers understand which recruitment agency was responsible for a job ad, for jobs posted outside of the SEEK API.
This functionality has seen limited usage, and is prone to confusion.
Most SEEK hirers do not use recruitment agencies in this way, and so these changes will not affect the majority of users.

This change will affect the following fields:

- [`PostingRequester.roleCode`] will no longer have `Agency` as a valid value; it will always return `Company`.
  This field is now deprecated, and will be removed at a later date.
- [`PostingRequester.id`] will no longer return an ID for a recruitment agency; it will now always be the ID of the hirer.
- [`PostingRequester.name`] will no longer return the name of a recruitment agency; it will now always be the name of the hirer.
- [`HiringOrganization.seekApiCapabilities`] will now never return `null` for agencies, as the [`HiringOrganization`] type will not be accessible for agency accounts.
- The [`hiringOrganization`] query will not return information for recruitment agencies.
  If your software has stored IDs for recruitment agencies, they will no longer work.

[`HiringOrganization.seekApiCapabilities`]: /schema/named-type/HiringOrganization#/field/seekApiCapabilities
[`HiringOrganization`]: /schema/named-type/HiringOrganization
[`hiringOrganization`]: /schema/query/hiringOrganization
[`PostingRequester.id`]: /schema/named-type/PostingRequester#/field/id
[`PostingRequester.name`]: /schema/named-type/PostingRequester#/field/name
[`PostingRequester.roleCode`]: /schema/named-type/PostingRequester#/field/roleCode
[`PostingRequester`]: /schema/named-type/PostingRequester
